import {
  default as FLOOD_ICON,
  default as FLOOD_NODE,
} from 'assets/FloodStageIcons/flood_stage_system.png';
import OVERWATCH_VMS from 'assets/icons/exacq.png';
import MANUAL_ROAD_CLOSURE from 'assets/map buttons/RescAlert Devices Manual Road Closures - Map Button.png';
import SIREN_GIANT_VOICE from 'assets/map buttons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) - Map button.png';
import TECHNOLOGY_BRIDGE from 'assets/map buttons/RescAlert Devices Technology Bridge - Map Button.png';
import { FaQuestion } from 'react-icons/fa';
import RESCALERT_DEVICE from '../../components/Nav/assets/Sidebar_Logo_Closed.png';

import L from 'leaflet';

//Flood Dynamic Icons
import stage_alarm_nocamera from 'assets/FloodStageIcons/stage_flooding.png';
import {
  default as stage_alarm_camera_cell,
  default as stage_alarm_camera_sat,
} from 'assets/FloodStageIcons/stage_flooding_camera.png';
import {
  default as stage_maintenance_no_camera,
  default as stage_offline_nocamera,
} from 'assets/FloodStageIcons/stage_offline.png';
import stage_maintenance_camera, {
  default as stage_offline_camera_cell,
  default as stage_offline_camera_sat,
} from 'assets/FloodStageIcons/stage_offline_camera.png';
import {
  default as stage_camera_cell,
  default as stage_camera_sat,
  default as stage_online_camera,
} from 'assets/FloodStageIcons/stage_online_camera.png';
import stage_slow_nocamera from 'assets/FloodStageIcons/stage_slow.png';
import {
  default as stage_slow_camera_cell,
  default as stage_slow_camera_sat,
} from 'assets/FloodStageIcons/stage_slow_camera.png';
import stage_warning_nocamera from 'assets/FloodStageIcons/stage_warning.png';
import {
  default as stage_warning_camera_cell,
  default as stage_warning_camera_sat,
} from 'assets/FloodStageIcons/stage_warning_camera.png';

//RescAlert Dynamic Icons
import rescalert from 'assets/resc_placeholder.png';
import rescalert_closure_closed from 'assets/rescalerticons/RescAlert Devices Manual Road Closures - Status Closed.png';
import rescalert_closure_open from 'assets/rescalerticons/RescAlert Devices Manual Road Closures - Status Open.png';
import rescalert_bridge_closed_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Closed (no camera).png';
import rescalert_bridge_closed_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Closed (with camera).png';
import rescalert_bridge_maintenance_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Maintenance (no camera).png';
import rescalert_bridge_maintenance_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Maintenance (with camera).png';
import rescalert_bridge_offline_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Offline (no camera).png';
import rescalert_bridge_offline_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Offline (with camera).png';
import rescalert_bridge_open_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Open (no camera).png';
import rescalert_bridge_open_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Open (with camera).png';
import rescalert_bridge_warning_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Warning (no camera).png';
import rescalert_bridge_warning_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Warning (with camera).png';

import rescalert_siren_alerting_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Alerting with camera.png';
import rescalert_siren_alerting_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Alerting.png';
import rescalert_siren_idle_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Idle with camera.png';
import rescalert_siren_idle_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Idle.png';
import rescalert_siren_maintenance_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Maintenance with camera.png';
import rescalert_siren_maintenance_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Maintenance.png';
import rescalert_siren_offline_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Offline with camera.png';
import rescalert_siren_offline_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Offline.png';
import { BuoyConditionsIcon } from 'features/Integrations/features/ConnectedDevices/features/Buoy/components/BuoyConditionsIcon/BuoyConditionsIcon';
import {
  currentThreshold,
  makeUSGSMarker,
} from 'features/Integrations/features/ConnectedDevices/features/DeviceMap/features/utils/usgsMarker.utils';
import {
  DeviceIsDeviceType,
  DeviceIsSystemType,
} from 'features/Integrations/utils/deviceComparison.utils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { GiBigWave } from 'react-icons/gi';
import { isDeviceDataStale } from 'utils/devices/staleness.utils';
import { capitalizeWord } from 'utils/strings/string.utils';

export const deviceImageList = {
  Flood: FLOOD_ICON,
  Stage: FLOOD_NODE,
  'RescAlert Devices': RESCALERT_DEVICE,
  RESCALERT: RESCALERT_DEVICE,
  'Manual Road Closure': MANUAL_ROAD_CLOSURE,
  'Technology Bridge_Flashing Lights': TECHNOLOGY_BRIDGE,
  'Technology Bridge_Siren/Giant Voice': SIREN_GIANT_VOICE,
  'Overwatch VMS': OVERWATCH_VMS,
  'Exacq Vision': OVERWATCH_VMS,
  'Buoy Conditions':
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      renderToStaticMarkup(
        React.createElement(BuoyConditionsIcon, {
          color: 'white',
          stroke: 'black',
          strokeWidth: 2,
          size: 35,
        }),
      ),
    ),
  USGS:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      renderToStaticMarkup(React.createElement(GiBigWave, { color: 'white', size: 35 })),
    ),
};

/**
 * Returns the icon for a group, using the following priority:
 * 1. If group.type exists, use deviceImageList[group.type]
 * 2. If deviceList is provided and group.devices has IDs, find the first matching device and use its icon
 * 3. If deviceList is provided and group.controllers has IDs, use the first controller's icon
 * 4. Fallback to 'RESCALERT' (default)
 * @param {object} group
 * @param {array} [deviceList] - Optional array of device objects
 * @returns icon (string or component)
 */
export const getDeviceIconForGroup = (group, deviceList) => {
  if (group.type) {
    return deviceImageList[group.type] || deviceImageList['RESCALERT'];
  }

  // Group type not found, attempt to find icon from devices in group if deviceList provided
  if (deviceList) {
    // Build a Map for faster lookups
    const deviceMap = new Map(deviceList.map((device) => [device.id, device]));

    // Try to get icon from first device in group.devices
    if (Array.isArray(group.devices) && group.devices.length > 0) {
      const firstDeviceId = group.devices[0] || null;
      if (firstDeviceId) {
        const device = deviceMap.get(firstDeviceId);
        if (device) {
          return getDynamicDeviceIcon(device);
        }
      }
    }
    // Fallback: Try first controller in group.controllers if no devices found
    if (Array.isArray(group.controllers) && group.controllers.length > 0) {
      const firstControllerId = group.controllers[0] || null;
      if (firstControllerId) {
        const controller = deviceMap.get(firstControllerId);
        if (controller) {
          return getDynamicDeviceIcon(controller);
        }
      }
    }
    // Fallback: default icon if no devices or controllers match in deviceList
    return deviceImageList['RESCALERT'];
  }

  // If no deviceList provided, use default
  return deviceImageList['RESCALERT'];
};

const iconSizes = [50, 50];

export const getDynamicDeviceIcon = (device, type = 'img', size = iconSizes) => {
  let icon = rescalert;
  switch (device?.system_type) {
    case 'Flood':
      icon = getFloodImage(device);
      size = [30, 60];
      break;
    case 'RescAlert Devices':
      icon = getRescAlertImage(device);
      break;
    case 'Exacq Vision':
      icon = OVERWATCH_VMS;
      size = [30, 30];
      break;
    case 'USGS':
      icon = makeUSGSMarker(device, undefined);
      size = [30, 30];
      break;
    default:
      icon = rescalert;
      size = [50, 50];
      break;
  }

  try {
    if (type === 'icon') {
      icon = imageToIcon(icon, size);
    }
  } catch (e) {
    console.error('Error for imageToIcon:', e, 'using default icon.');
    icon = imageToIcon(rescalert, [50, 50]);
  }

  return icon || <FaQuestion />;
};

export const getDynamicDeviceIconFromType = (systemType, deviceType, size = iconSizes) => {
  if (DeviceIsSystemType({ system_type: systemType }, 'Flood'))
    return imageToIcon(stage_online_camera, [30, 60]);
  else if (
    String(deviceType || '')
      .toLowerCase()
      .includes('buoy')
  )
    return imageToIcon(deviceImageList['Buoy Conditions'], [30, 30]);
  else if (systemType.toLowerCase() === 'rescalert devices')
    switch (deviceType) {
      case 'Technology Bridge_Flashing Lights':
        return imageToIcon(rescalert_bridge_open_nocamera, size);
      case 'Technology Bridge_Siren/Giant Voice':
        return imageToIcon(rescalert_siren_idle_nocamera, size);
      case 'Manual Road Closure':
        return imageToIcon(rescalert_closure_open, size);
      case 'Buoy Conditions':
        return imageToIcon(deviceImageList['Buoy Conditions'], size);

      default:
        break;
    }
  else if (systemType.toLowerCase() === 'exacq vision') return imageToIcon(OVERWATCH_VMS, size);
  return imageToIcon(rescalert, size);
};

export const imageToIcon = (image, size, anchor) => {
  return L.icon({
    iconUrl: image,
    iconSize: size,
  });
};

export function getDeviceStatusCode(device) {
  if (!device) return;
  //System type determines which status function to call
  if (DeviceIsSystemType(device, 'Flood')) return stageNodeStatus(device);
  if (DeviceIsSystemType(device, 'RescAlert Devices')) return getRescAlertStatus(device);
  if (DeviceIsSystemType(device, 'Exacq Vision')) return getExacqVisionStatus(device);
  if (DeviceIsSystemType(device, 'USGS')) return getUSGSStatus(device);
  console.error('Unhandled Node Status for device:', device);
  return;
}

//FLOOD DEVICE FUNCTIONS

/**
 * Rising / Dropping map icons for Stage nodes — yellow, with an up or down
 * arrow, so the trend is discernable from the map view. No PNG variant exists
 * for these statuses (they fell through to the Online icon), so they are drawn
 * as SVG data URIs in the composition of the stage_*.png set: navy body,
 * colored ring, status plate, waves below (same pattern as the Buoy/USGS
 * SVG markers).
 */
const STAGE_TREND_YELLOW = '#FFD400';
const STAGE_BODY_NAVY = '#1B2A4E';
const STAGE_WAVE_BLUE = '#1558C6';

const stageTrendIcon = (direction) => {
  const label = direction === 'up' ? 'RISING' : 'DROPPING';
  const arrow =
    direction === 'up'
      ? '150,100 202,165 172,165 172,232 128,232 128,165 98,165'
      : '150,232 202,167 172,167 172,100 128,100 128,167 98,167';
  const wave = (y) => `M20,${y} q43,32 87,0 t87,0 t87,0`;
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 600">` +
    `<rect x="28" y="0" width="90" height="40" rx="10" fill="${STAGE_BODY_NAVY}"/>` +
    `<rect x="5" y="15" width="290" height="385" rx="35" fill="${STAGE_BODY_NAVY}"/>` +
    `<circle cx="150" cy="165" r="93" fill="none" stroke="${STAGE_TREND_YELLOW}" stroke-width="36"/>` +
    `<polygon points="${arrow}" fill="${STAGE_TREND_YELLOW}"/>` +
    `<rect x="55" y="315" width="190" height="60" rx="6" fill="#ffffff"/>` +
    `<text x="150" y="359" text-anchor="middle" font-family="Arial, Helvetica, sans-serif"` +
    ` font-size="40" font-weight="bold" fill="${STAGE_TREND_YELLOW}" stroke="#000000"` +
    ` stroke-width="1.5" paint-order="stroke" textLength="172" lengthAdjust="spacingAndGlyphs">${label}</text>` +
    `<rect x="95" y="400" width="110" height="45" rx="10" fill="${STAGE_BODY_NAVY}"/>` +
    `<path d="${wave(495)}" fill="none" stroke="${STAGE_WAVE_BLUE}" stroke-width="26" stroke-linecap="round"/>` +
    `<path d="${wave(550)}" fill="none" stroke="${STAGE_WAVE_BLUE}" stroke-width="26" stroke-linecap="round"/>` +
    `</svg>`;
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
};

const stage_rising_icon = stageTrendIcon('up');
const stage_dropping_icon = stageTrendIcon('down');

function getFloodImage(device) {
  let status = 'Online';

  const deviceDataArray = Array.isArray(device.data) ? device.data : []; // Ensures that device data is always an array
  if (deviceDataArray.length === 0) return stage_offline_nocamera;

  const sortedDeviceData = [...deviceDataArray].sort((a, b) => b.ts - a.ts); // Created a sorted copy of the data
  if (!sortedDeviceData[0]) return stage_offline_nocamera; // Deals with null and undefined entries

  status = stageNodeStatus({ ...device }); // Pass a copy to avoid mutation

  if (status === 'Offline') {
    return device?.data[0].gatewayType
      ? stage_offline_camera_cell
      : device?.data[0]?.pict
        ? stage_offline_camera_sat
        : stage_offline_nocamera;
  }

  if (status === 'Slow') {
    return device?.data[0].gatewayType
      ? stage_slow_camera_cell
      : device?.data[0]?.pict
        ? stage_slow_camera_sat
        : stage_slow_nocamera;
  }

  if (status === 'Rising') return stage_rising_icon;
  if (status === 'Dropping') return stage_dropping_icon;

  if (status === 'Warning') {
    return device?.data[0].gatewayType
      ? stage_warning_camera_cell
      : device?.data[0]?.pict
        ? stage_warning_camera_sat
        : stage_warning_nocamera;
  }

  if (status === 'Flooding') {
    if (device?.data[0]?.pict) {
      return device?.data[0].gatewayType ? stage_alarm_camera_cell : stage_alarm_camera_sat;
    }
    return stage_alarm_nocamera;
  }

  if (status === 'Maintenance') {
    if (device?.data[0]?.pict) {
      return device?.data[0].gatewayType ? stage_maintenance_camera : stage_maintenance_no_camera;
    }
    return stage_alarm_nocamera;
  }

  if (device?.data[0]?.pict) {
    return device?.data[0].gatewayType ? stage_camera_cell : stage_camera_sat;
  }

  return stage_online_camera;
}

/**
 * The resting status of a Flood/Stage device when no threshold is crossed.
 *
 * `reporting_mode` is written by the gauge ingestion (Online / Slow / Offline)
 * or by the StageFloodSim on its first tick. A device nobody has written it
 * for used to come out of here as `undefined`, which the badge logged as
 * "Invalid status" and showed as Offline — including every simulated device
 * before its first tick. Mike, 2026-08-28: "simulated devices should show
 * online and maybe offline if we set them not to collect data or disable
 * them." So, with a datapoint present and no reporting_mode: simulating
 * (`RI_Device.sim_mode` 1 donor / 2 scenario) is Online; not simulating —
 * disabled, or a real gauge that has never reported — is Offline. Never
 * undefined.
 */
function restingStageStatus(device) {
  if (device?.reporting_mode) return device.reporting_mode;
  return Number(device?.sim_mode) > 0 ? 'Online' : 'Offline';
}

function stageNodeStatus(device) {
  if (device.reporting_mode === 'Offline') return device.reporting_mode;

  const dataArray = Array.isArray(device.data) ? device.data : [];
  const info = dataArray[0];
  if (!info) return 'Offline';
  // The stale rule: a row older than the threshold is not a current status.
  if (isDeviceDataStale(device, info)) return 'Offline';
  const settings = device.device_settings || {};

  let status = restingStageStatus(device);
  if (
    // info.depthInd ||
    info.depth1 >= settings?.depthDet2 ||
    info.depth1 >= settings?.depthDet3
  ) {
    status = 'Flooding';
  } else if (info.ffi1) {
    return 'Rising';
  } else if (info.drInd) {
    return 'Dropping';
  } else if (info.depth1 >= settings.depthDet1) {
    status = 'Warning';
  }

  return status;
}

//RESCALERT DEVICE FUNCTIONS

/**
 * Gets the appropriate RescAlert image based on device data and status
 *
 * MRC defaults to open |
 * Tech Bridge defaults to offline
 *
 * @param   {[device]}  device  [device to get image for]
 *
 * @return  {[url]}        [image to use for device icon]
 */
function getRescAlertImage(device) {
  try {
    if (device?.data?.length > 0) {
      const info = device?.data[0];
      const status = getRescAlertStatus(device);

      switch (device.device_type) {
        case 'Manual Road Closure':
          return info?.status ? rescalert_closure_closed : rescalert_closure_open;
        case 'Technology Bridge_Flashing Lights':
          switch (status) {
            case 'Warning':
              return info?.pict
                ? rescalert_bridge_warning_camera
                : rescalert_bridge_warning_nocamera;
            case 'Maintenance':
              return info?.pict
                ? rescalert_bridge_maintenance_camera
                : rescalert_bridge_maintenance_nocamera;
            case 'Closed':
              return info?.pict ? rescalert_bridge_closed_camera : rescalert_bridge_closed_nocamera;
            case 'Offline':
              return info?.pict
                ? rescalert_bridge_offline_camera
                : rescalert_bridge_offline_nocamera;
            case 'Open':
              return info?.pict ? rescalert_bridge_open_camera : rescalert_bridge_open_nocamera;
            default:
              return info?.pict
                ? rescalert_bridge_offline_camera
                : rescalert_bridge_offline_nocamera;
          }
        case 'Technology Bridge_Siren/Giant Voice':
          switch (status) {
            case 'Maintenance':
              return info?.pict
                ? rescalert_siren_maintenance_camera
                : rescalert_siren_maintenance_nocamera;
            case 'Alerting':
              return info?.pict
                ? rescalert_siren_alerting_camera
                : rescalert_siren_alerting_nocamera;
            case 'Offline':
              return info?.pict ? rescalert_siren_offline_camera : rescalert_siren_offline_nocamera;
            case 'Idle':
              return info?.pict ? rescalert_siren_idle_camera : rescalert_siren_idle_nocamera;
            default:
              return info?.pict ? rescalert_siren_offline_camera : rescalert_siren_offline_nocamera;
          }
        case 'Buoy Conditions':
          return (
            'data:image/svg+xml;utf8,' +
            encodeURIComponent(
              renderToStaticMarkup(
                React.createElement(BuoyConditionsIcon, {
                  color: 'white',
                  stroke: 'black',
                  strokeWidth: 2,
                  size: 35,
                  borderStroke: 'black',
                  borderStrokeWidth: 2,
                }),
              ),
            )
          );
        default:
          //!! IF NO IMAGE RETURN THEN SEND BACK THE DEFAULT GENERIC DEFAULT RESCALERT ICON
          return rescalert;
      }
    }
    //Final catch all if no data available
    else {
      switch (device.device_type) {
        case 'Manual Road Closure':
          return rescalert_closure_open;
        case 'Technology Bridge_Flashing Lights':
          return rescalert_bridge_offline_nocamera;
        case 'Technology Bridge_Siren/Giant Voice':
          return rescalert_siren_offline_nocamera;
        case 'Buoy Conditions':
          return (
            'data:image/svg+xml;utf8,' +
            encodeURIComponent(
              renderToStaticMarkup(
                React.createElement(BuoyConditionsIcon, {
                  color: 'white',
                  stroke: 'black',
                  strokeWidth: 2,
                  size: 35,
                  borderStroke: 'black',
                  borderStrokeWidth: 2,
                }),
              ),
            )
          );
        default:
          //!! IF NO IMAGE RETURN THEN SEND BACK THE DEFAULT GENERIC DEFAULT RESCALERT ICON
          return rescalert;
      }
    }
  } catch (e) {
    console.error('Error in getRescAlertImage:', e);
  }
}

export function displayStatusOptions(device) {
  if (
    device?.device_type == 'Technology Bridge_Siren/Giant Voice' ||
    device?.deviceType == 'RescAlert Devices Technology Bridge_Siren/Giant Voice'
  ) {
    return {
      0: 'Idle',
      1: 'Alerting',
      '-1': 'Maintenance',
    };
  }
  return {
    0: 'Open',
    1: 'Closed',
    '-1': 'Warning',
  };
}

export function getRescAlertStatus(device) {
  const info = device?.data?.[0];
  if (device?.is_offline || !info || info?.is_offline) return 'Offline';
  // The stale rule. A no-op for the event-only types (siren, lights, MRC): see staleness.utils.
  if (isDeviceDataStale(device, info)) return 'Offline';

  const { device_type, kill_switch } = device;
  const statusVal = info.status;

  // --- Manual Road Closure ---
  if (device_type === 'Manual Road Closure') {
    return info.status ? 'Closed' : 'Open';
  }

  // --- Technology Bridge devices ---
  if (
    device_type === 'Technology Bridge_Flashing Lights' ||
    device_type === 'Technology Bridge_Siren/Giant Voice'
  ) {
    if (kill_switch || statusVal === -1) return 'Maintenance';
    if (statusVal === -2) return 'Offline';
    if (statusVal === -3) return 'API Error';

    const techBridgeStatusMap = {
      'Technology Bridge_Flashing Lights': { 0: 'Open', 1: 'Closed' },
      'Technology Bridge_Siren/Giant Voice': { 0: 'Idle', 1: 'Alerting' },
    };

    return techBridgeStatusMap[device_type][statusVal] || 'Unknown';
  }

  if (DeviceIsDeviceType(device, 'Buoy Conditions')) return getBuoyStatus(device);

  // --- Generic fallback ---
  switch (statusVal) {
    case -1:
      return 'Maintenance';
    case -2:
      return 'Offline';
    case -3:
      return 'API Error';
    case 0:
      return 'Inactive';
    case 1:
      return 'Active';
    default:
      return 'Unknown';
  }
}

export function getExacqVisionStatus(device) {
  // Standard convention: is_offline truthy (1) = Offline, falsy (0) = Online.
  return device?.is_offline ? 'Offline' : 'Online';
}

export function getUSGSStatus(device) {
  if (!device || !device.data || device.data.length === 0) return 'Offline';
  if (isDeviceDataStale(device, device.data[0])) return 'Offline';
  const status = capitalizeWord(currentThreshold(device));
  if (status === 'NoFloodStages' || status === 'NotFlooding') return 'Online';
  else return status; // Returns the specific flood stage as status for USGS devices
}

export function getBuoyStatus(device) {
  if (!device || !Array.isArray(device.data) || device.data.length === 0) return 'Offline';
  if (isDeviceDataStale(device, device.data[0])) return 'Offline';
  return 'Online';
}
